export default __webpack_public_path__ + "static/media/about-wall.b86d0828.jpg";